import { useTranslation } from 'react-i18next';
import { FolderTree } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/core/lib/utils';

interface OrganizationUnitEmptyStateProps {
  onCreateFirst: () => void;
  className?: string;
}

export function OrganizationUnitEmptyState({
  onCreateFirst,
  className,
}: OrganizationUnitEmptyStateProps) {
  const { t } = useTranslation('organizationUnits');

  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-4 py-16', className)}
      data-testid="organization-units-empty-state"
    >
      <div className="rounded-full bg-muted p-4">
        <FolderTree className="h-8 w-8 text-muted-foreground" />
      </div>
      <div className="text-center">
        <h3 className="text-lg font-medium">{t('empty.title')}</h3>
        <p className="mt-1 text-sm text-muted-foreground">{t('empty.description')}</p>
      </div>
      <Button onClick={onCreateFirst} data-testid="organization-units-create-first-button">
        {t('empty.createFirst')}
      </Button>
    </div>
  );
}
